import { useEffect, useRef, useState } from 'react';
import { useAppSelector } from '@hooks/reduxHooks';
import { useActiveSessions } from '@queries/queries';

const useActivity = () => {
  const [visibility, setVisibility] = useState(true);
  const timer = useRef<NodeJS.Timer | null>(null);
  const version = useAppSelector(state => state?.userReducer?.version);
  const stompClient = useAppSelector(state => state?.userReducer?.stompClient);
  const { data } = useActiveSessions();

  const send = ({ status }: { status: 'ONLINE' | 'OFFLINE' }) => {
    if (stompClient && stompClient?.connected)
      stompClient?.send('/app/version', {}, JSON.stringify({ version, status, sessionId: data?.activeSession?.id }));
  };

  useEffect(() => {
    const windowVisible = () => {
      setVisibility(!document.hidden);
      if (document?.hidden) {
        send({ status: 'OFFLINE' });
      } else {
        send({ status: 'ONLINE' });
      }
    };

    document.addEventListener('visibilitychange', windowVisible);
    return () => {
      document.removeEventListener('visibilitychange', windowVisible);
    };
  }, [stompClient, data, version]);

  useEffect(() => {
    if (stompClient) {
      if (timer.current) {
        clearInterval(timer.current);
      }
      if (visibility) {
        timer.current = setInterval(() => {
          send({ status: 'ONLINE' });
        }, 10000);
      }
    } else if (timer.current) {
      clearInterval(timer.current);
    }
  }, [stompClient, data, version, visibility]);

  return null;
};

export default useActivity;
